<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: "studentProjectLayout"
    }
</script>

<style scoped>

</style>